import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import {MatFormFieldModule} from '@angular/material/form-field';

import { LanguageService } from '../../../../core/services/language/language.service';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { NavigationStart, Router,Event, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';


@Component({
  selector: 'app-select-language',
  imports: [ MatFormFieldModule, MatSelectModule, MatInputModule, FormsModule, MatButtonModule, MatMenuModule],
  templateUrl: './select-language.html',
  styleUrl: './select-language.scss'
})
export class SelectLanguage implements OnInit{
  public languageService: LanguageService = inject(LanguageService);
  router = inject(Router);
  public hideLang: boolean = false;
  classLand: string = 'not-active';

    sizePanel(): string{ 
    const bd = document.querySelector('body') as HTMLBodyElement;
    
    const rWidth:number = bd.offsetWidth as number;   
    let nowWidth = "190px";
    
    if(rWidth >= 1366 || rWidth <= 1919){
      nowWidth = "9.896vw";
    }

    if(rWidth >= 768 || rWidth < 1366){
      nowWidth = "135.13px";
    }

    if(rWidth < 768){
      nowWidth = "32.5vw";
    }

    return nowWidth;
  }

  ngOnInit(): void {
    // Initialization logic can go here
    this.router.events
    .pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
      this.hideLang = event.url.includes("game-itself/");
    });
  }

  isClass(){
    let classMes = 'active';
    if(this.router.url.includes("single-game/")){
      classMes = 'not-active';
    }
    if(this.router.url.includes("coop-game/")){
      classMes = 'not-active';
    }
    
    return classMes;
  }

}
